import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ChevronDown: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.26715 6.4811C2.93578 6.15037 2.93624 5.61332 3.26818 5.28316C3.59853 4.95458 4.13243 4.95517 4.46205 5.28448L8.00247 8.82156L11.5377 5.2852C11.8672 4.95556 12.4014 4.95479 12.7318 5.2835C13.0636 5.61352 13.0642 6.1503 12.7332 6.48106L8.4211 10.7891C8.1898 11.0201 7.81506 11.0202 7.58365 10.7893L3.26715 6.4811Z"
      fill="currentColor"
    />
  </svg>
);
